"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputChipMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _TagCloseButton = require("../../components/TagCloseButton/TagCloseButton.styles");
var _buttonStateMixin = require("../buttonStateMixin");
var _disabledMixin = require("../disabledMixin");
var _sizeMixin = require("../sizeMixin");
var _typographyMixin = require("../typographyMixin");
var _ChipMixin = require("./ChipMixin");
/** @class InputChipMixin */
/** @method */
var InputChipMixin = function InputChipMixin(props) {
  return (0, _styledToken.default)({
    borderWidth: "Chip.pressed.borderWidth",
    color: "Chip.fontColor",
    closeButtonColorActive: 'Chip.closeButton.colorActive',
    closeButtonOpacityActive: 'Chip.closeButton.opacityActive',
    focusShadow: 'Chip.boxShadow.focus',
    fontType: "Chip.fontType",
    height: "Chip.height"
  }, function (_ref) {
    var borderWidth = _ref.borderWidth,
      color = _ref.color,
      closeButtonColorActive = _ref.closeButtonColorActive,
      closeButtonOpacityActive = _ref.closeButtonOpacityActive,
      focusShadow = _ref.focusShadow,
      fontType = _ref.fontType,
      height = _ref.height;
    return (0, _styledComponents.css)(["", " display:inline-flex;align-items:center;vertical-align:top;border:", "px solid;&:focus-within{box-shadow:", ";}& > ", "{margin-top:0;}", "{color:", ";margin-left:0;", "{box-shadow:none;}&[aria-disabled='false']:active{color:", ";opacity:", ";}&[aria-disabled='true']:hover,&[aria-disabled='true']:active{opacity:1;}}", " ", " ", " ", ""], (0, _ChipMixin.ChipMixin)(props), borderWidth, focusShadow, _Icon.StyledIcon, _TagCloseButton.StyledTagCloseButton, color, _Icon.StyledIcon, closeButtonColorActive, closeButtonOpacityActive, (0, _buttonStateMixin.buttonStateMixin)('Pressed')(Object.assign({
      buttonType: 'tertiary',
      interactive: false
    }, props)), (0, _disabledMixin.disabledMixin)(props), (0, _sizeMixin.sizeMixin)({
      fontType: fontType,
      borderWidth: borderWidth * 2,
      size: height
    })(props), (0, _typographyMixin.typographyMixin)(Object.assign({}, props, {
      fontType: fontType,
      fontTypeIconAlignment: false
    })));
  })(props);
};
exports.InputChipMixin = InputChipMixin;